import {
  CheckCircleOutlined,
  CheckOutlined,
  CloseOutlined,
  PlusOutlined,
  ReloadOutlined,
  StopOutlined,
  SwapOutlined,
} from '@ant-design/icons';
import { Button, Flex, Popconfirm, Segmented, Space } from 'antd';
import PropTypes from 'prop-types';

const OperationEntityToolbar = ({
  applicableCount,
  confirming,
  matching,
  onBatchSetEnabled,
  onCancelMatching,
  onAppendMatching,
  onCreate,
  onMove,
  onRecommendationFilterChange,
  onStartMatching,
  recommendationAvailable,
  recommendationFilter,
  recommendationRefreshing,
  selectedCount,
}) => (
  <Flex justify="flex-end" align="center" gap="middle" wrap>
    <Space wrap>
      <Button type="primary" icon={<PlusOutlined />} onClick={onCreate}>
        新建区域
      </Button>
      <Button disabled={!selectedCount} icon={<SwapOutlined />} onClick={onMove}>
        批量调整上级
      </Button>
      <Popconfirm
        title={`确认启用选中的 ${selectedCount} 个门店？`}
        disabled={!selectedCount}
        onConfirm={() => onBatchSetEnabled(true)}
      >
        <Button disabled={!selectedCount} icon={<CheckCircleOutlined />}>
          批量启用
        </Button>
      </Popconfirm>
      <Popconfirm
        title={`确认停用选中的 ${selectedCount} 个门店？`}
        description="停用后不纳入经营分析，包括历史期间；闭店不等于停用。"
        disabled={!selectedCount}
        onConfirm={() => onBatchSetEnabled(false)}
      >
        <Button danger disabled={!selectedCount} icon={<StopOutlined />}>
          批量停用
        </Button>
      </Popconfirm>
      {matching ? (
        <>
          <Segmented
            options={[
              { label: '全部', value: 'all' },
              { label: '冲突', value: 'conflict' },
              { label: '未匹配', value: 'unmatched' },
            ]}
            value={recommendationFilter}
            onChange={onRecommendationFilterChange}
          />
          <Button icon={<CloseOutlined />} onClick={onCancelMatching}>
            取消推荐
          </Button>
          <Button
            type="primary"
            icon={<CheckOutlined />}
            disabled={!applicableCount}
            loading={confirming}
            onClick={onAppendMatching}
          >
            追加可应用负责人（{applicableCount}）
          </Button>
        </>
      ) : (
        <Button
          icon={<ReloadOutlined />}
          disabled={!recommendationAvailable}
          loading={recommendationRefreshing}
          onClick={onStartMatching}
        >
          重新推荐
        </Button>
      )}
    </Space>
  </Flex>
);

OperationEntityToolbar.propTypes = {
  applicableCount: PropTypes.number.isRequired,
  confirming: PropTypes.bool.isRequired,
  matching: PropTypes.bool.isRequired,
  onBatchSetEnabled: PropTypes.func.isRequired,
  onCancelMatching: PropTypes.func.isRequired,
  onAppendMatching: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onMove: PropTypes.func.isRequired,
  onRecommendationFilterChange: PropTypes.func.isRequired,
  onStartMatching: PropTypes.func.isRequired,
  recommendationAvailable: PropTypes.bool.isRequired,
  recommendationFilter: PropTypes.oneOf(['all', 'conflict', 'unmatched']).isRequired,
  recommendationRefreshing: PropTypes.bool.isRequired,
  selectedCount: PropTypes.number.isRequired,
};

export default OperationEntityToolbar;
